import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: '',
    title: 'sm:heading-2xl-desk heading-2xl sm:leading-[110%]',
    description: 'heading-m mt-3 mb-6',
    captcha: 'text-tertiary heading-xs mt-3',
    agreement: 'mt-6',
    button: 'mt-6 w-full'
  }
});
